import useTable from '../../../hooks/useTable';
import { Table } from '../../Table';
import { TableComponentProps } from '../types';

const columnLables = {
  predominant_aif_type: {
    name: 'Predominant AIF Type',
    order: 57
  }
};

export function InvestmentStrategies2({
  funds,
  currentDataKey,
  onChangeFund,
  schema,
  isStaticTemplate,
  isMultiFunds
}: TableComponentProps) {
  const {
    rows: rows,
    columns: columns,
    onChange: onChange
  } = useTable({
    data: funds[currentDataKey]?.fund_data?.INVESTMENT_STRATEGIES,
    onChangeFund,
    schema: schema.INVESTMENT_STRATEGIES,
    isStaticTemplate,
    requiredFields:
      funds[currentDataKey]?.required_tables?.INVESTMENT_STRATEGIES?.field_names || [],
    funds,
    isMultiFunds,
    tableName: 'INVESTMENT_STRATEGIES',
    columnLables
  });

  return (
    <Table
      id="reporttables-investment-strategies-2-table"
      stickyLeftColumns={isMultiFunds && Object.keys(funds).length > 2 ? 2 : null}
      handleChanges={onChange}
      columns={columns}
      rows={rows}
    />
  );
}
